import { useSelector, useDispatch } from 'react-redux';
import { selectChannel  } from 'app/store/channelsSlice';
import { selectTopicsByParentId, selectEntryById, selectClientsByGroupId } from 'app/store/groupsSlice';
import { useParams } from 'react-router-dom';
import { setCurrentFolder } from 'app/store/fileItemsSlice';
import TopicSidebarListItem from 'app/shared-components/channel/TopicSidebarListItem';
import ClientSidebarListItem from './ClientSidebarListItem';
import SidebarListItem from 'app/shared-components/layout/SidebarListItem';
import LeftSidebarMenu from 'app/shared-components/layout/LeftSidebarMenu';
import capitalizeFirstLetter from 'app/shared-components/util/capitalizeFirstLetter';


function ChannelLeftSidebarContent({closeSidebar, type, items}) {
  const dispatch = useDispatch();
  const routeParams = useParams();
  const { groupId } = routeParams;
  const topics = useSelector(selectTopicsByParentId(type, groupId));
  const clients= useSelector(selectClientsByGroupId(groupId));
  const group= useSelector(selectChannel(groupId));
  const rootFolderId= group?.entity?.folderId;
  const entry= useSelector(selectEntryById(groupId));
  const unread= entry?.unread;
  const threadsUnread= entry?.threadsUnread;
  const topicsUnread= entry?.topicsUnread;
  const clientsUnread=  entry?.clientsUnread;
  const appBaseUrl= "/apps/" + type + "/" + groupId;
  const displayType= capitalizeFirstLetter(type);
  const permissions = group ? group.callerPermissions : {};
  const name = group ? group.name : "";
  const extraItems= items ? items : [];
  const isGuest = permissions?.guest;

  function onClickFiles(){
    dispatch(setCurrentFolder(rootFolderId));
    closeSidebar();
  }

  return (
	<LeftSidebarMenu back={{link: "/apps/" + type + "s", text: "My " + displayType + "s"}}>
	
		      <SidebarListItem link={appBaseUrl}
           			   key="main"
           			   icon="heroicons-outline:home"
           			   text={name}
           			   onClick={closeSidebar}
           			   unread={unread}/>

        { topics && topics.length > 0 &&
           <SidebarListItem key="topicChannels"
                         icon="heroicons-outline:hashtag"
                         text="Topic Channels"
                         unread={topicsUnread}>
              {topics.map((topic) => (
                <TopicSidebarListItem type={type} topicId={topic.id} groupId={groupId} key={topic.id} onClick={closeSidebar} />
              ))}
           </SidebarListItem>
        }

        { clients && clients.length > 0 &&
        <SidebarListItem key="clientChannels"
                         icon="material-outline:portrait"
                         text="Client Channels"
                         unread={clientsUnread}>
            {clients.map((client) => (
                <ClientSidebarListItem type={type} clientId={client.id} groupId={groupId} key={client.id} onClick={closeSidebar} />
            ))}
        </SidebarListItem>
        }

        <SidebarListItem link={appBaseUrl + "/threads"}
                         key="threads"
                         icon="heroicons-outline:chat-bubble-bottom-center-text"
                         text="Threads"
                         onClick={closeSidebar}
                         unread={threadsUnread}/>


        {!isGuest && (
         <SidebarListItem link={appBaseUrl + "/files"}
           			   key="files"
           			   icon="heroicons-outline:folder-open"
           			   onClick={onClickFiles}
           			   text={"Files"}/>
        )}

        {!isGuest && (
            <SidebarListItem link={appBaseUrl + "/members"}
                             key="members"
                             icon="material-outline:people_outline"
                             onClick={closeSidebar}
                             text={"Members"}/>
        )}
       
          <SidebarListItem link={appBaseUrl + "/topics"}
           			   key="topics"
           			   icon="heroicons-outline:list-bullet"
           			   onClick={closeSidebar}
           			   text={"Manage Topics"}/>
          
          {(permissions.admin || permissions.owner)  && (   
          <SidebarListItem link={appBaseUrl + "/admin"}
           			   key="admin"
           			   icon="heroicons-outline:cog"
           			   onClick={closeSidebar}
           			   text={"Admin"}/>
          )}

        {extraItems.map((item) => {
            // First check if the item should be shown based on permissions
            const shouldShow = !item.requiresAdmin || (item.requiresAdmin && (permissions.admin || permissions.owner));
            if (!shouldShow) return null;

            // If item has children, render as parent with nested items
            if (item.children && item.children.length > 0) {
                return (
                    <SidebarListItem
                        key={item.key}
                        icon={item.icon}
                        text={item.text}
                        expanded={item.expanded}
                    >
                        {item.children.map((childItem) => {
                            // Check permissions for child items as well
                            const shouldShowChild = !childItem.requiresAdmin ||
                                (childItem.requiresAdmin && (permissions.admin || permissions.owner));
                            if (!shouldShowChild) return null;

                            return (
                                <SidebarListItem
                                    link={childItem.link}
                                    key={childItem.key}
                                    icon={childItem.icon}
                                    onClick={closeSidebar}
                                    text={childItem.text}
                                />
                            );
                        })}
                    </SidebarListItem>
                );
            }

            // If no children, render as regular item
            return (
                <SidebarListItem
                    link={item.link}
                    key={item.key}
                    icon={item.icon}
                    onClick={closeSidebar}
                    text={item.text}
                />
            );
        })}

          			   
	</LeftSidebarMenu>
  );
}

export default ChannelLeftSidebarContent;
